import { apiFetch } from './config';

export interface ProposalTopic {
  topic_id: string;
  topic_name: string;
  target_company_id: string;
  target_company_name?: string;
  approver_email: string;
  can_submit: boolean;
  can_configure: boolean;
}
export interface DesignProposal {
  design_request_id?: string;
  proposal_id: string;
  topic_id: string;
  title: string;
  description: string;
  source_company_id: string;
  source_company_name?: string;
  target_company_id: string;
  target_company_name?: string;
  status: 'submitted' | 'approved' | 'rejected';
  submitted_by: string;
  submitted_at: string;
  decided_by?: string | null;
  decided_at?: string | null;
  decision_reason?: string | null;
  can_decide: boolean;
}
async function action<T>(name: string, fields: Record<string, unknown> = {}) {
  const response = await apiFetch<any>('/api/dispatches/action', {
    method: 'POST', body: JSON.stringify({ action: name, ...fields }),
  });
  if (!response.success) return { success: false, error: response.error };
  const body = response.data?.data || response.data;
  if (!Array.isArray(body?.Records)) return { success: false, error: 'Invalid proposal response' };
  return { success: true, data: body.Records as T[] };
}
export const proposalsApi = {
  topics: (company_id?: string) => action<ProposalTopic>('list_proposal_topics', company_id ? { company_id } : {}),
  list: (company_id?: string) => action<DesignProposal>('list_proposals', company_id ? { company_id } : {}),
  submit: (fields: { topic_id: string; title: string; description: string }, company_id?: string) => action<DesignProposal>('submit_proposal', { ...fields, ...(company_id ? { company_id } : {}) }),
  decide: (proposal_id: string, decision: 'approve' | 'reject', reason: string, company_id?: string) =>
    action<DesignProposal>(`${decision}_proposal`, { proposal_id, reason, ...(company_id ? { company_id } : {}) }),
};
